import { BaseDevice, CustomLayout } from '../../base_device'
import list_icon from '@/assets/img/device/fe87/icon.png'
import { DevicePid, EffectIndex, KK } from '@/define/define'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { na87VKCodes } from './../keycode/vkeycode'
import { getDeviceKeySquare } from './../keysquare/keysquare'
import { generateArray } from '@/tool/utility'

export class FE87V2MuYan extends BaseDevice {
  name: string = 'Fe87_V2_MuYAN_Switch'
  icon: string = list_icon
  width: number = 777
  magneticAxis: boolean = false

  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = {
    [LightEffectMode.Close]: 18,
    [LightEffectMode.Wave_White]: 0,
    [LightEffectMode.HorizontalCycle_White]: 1,
    [LightEffectMode.Waterfall_White]: 2,
    [LightEffectMode.SpinningWindmill_white]: 3,
    [LightEffectMode.RainbowDream_mg63]: 4,
    [LightEffectMode.SineWave_mg63]: 5,
    [LightEffectMode.DoubleBeacon_White]: 6,
    [LightEffectMode.RainCurtain_White]: 7,
    [LightEffectMode.StaticBright_White]: 8,
    [LightEffectMode.Breathing_White]: 9,
    [LightEffectMode.Static_2]: 10,

    [LightEffectMode.KeyRipple_pro]: 11,
    [LightEffectMode.InstantFlash_pro]: 12,
    [LightEffectMode.ClickHighlight_pro]: 13,

    [LightEffectMode.HueBreathing_mg63]: 14,
    [LightEffectMode.Prosperity_White]: 15,
    [LightEffectMode.Fleeting_White]: 16,
    // [LightEffectMode.Custom]: 17,

    // [LightEffectMode.SideStatic]: 0x0,
    // [LightEffectMode.SideFleeting]: 0x1,
    // [LightEffectMode.SideSpectrumCycle]: 0x2,
    // [LightEffectMode.SideBreathing]: 0x3,
  }

  superResponse: boolean = false
  inoperableKeys: KK[] = [0x55, 0x00]

  y_number: number = 10
  vkcodes = na87VKCodes
  square = getDeviceKeySquare(DevicePid.IROKNA87)

  minDelayTimer: number = 1
  maxDelayTimer: number = 4095

  resetDes = ''
  fnDisableKeys: KK[] = [0x29, 0x3a, 0x3b, 0x3c, 0x3d, 0x3e, 0x3f, 0x40, 0x41, 0x42, 0x43, 0x44, 0x45, 0x2d, 0x16, 0x1b, 0xe0, 0xe3, 0xe2, 0xe6, 0x1, 0xe4, 0x50, 0x51, 0x4f, 0x52]

  customLayout: CustomLayout = {
    0x3a: this.createSquare(41),
    0x3e: this.createSquare(17, 2),
    0x42: this.createSquare(17, 2),
    0x46: this.createSquare(12, 2),

    0x35: this.createSquare(2, this.y_number),
    0x1e: this.createSquare(2, this.y_number),
    0x1f: this.createSquare(2, this.y_number),
    0x20: this.createSquare(2, this.y_number),
    0x21: this.createSquare(2, this.y_number),
    0x22: this.createSquare(2, this.y_number),
    0x23: this.createSquare(2, this.y_number),
    0x24: this.createSquare(2, this.y_number),
    0x25: this.createSquare(2, this.y_number),
    0x26: this.createSquare(2, this.y_number),
    0x27: this.createSquare(2, this.y_number),
    0x2d: this.createSquare(2, this.y_number),
    0x2e: this.createSquare(2, this.y_number),
    0x2a: this.createSquare(2, this.y_number, 67.5),
    0x49: this.createSquare(12, this.y_number),
    0x4a: this.createSquare(2, this.y_number),
    0x4b: this.createSquare(2, this.y_number),
    0x2b: this.createSquare(2, 2, 67.5),
    0x4c: this.createSquare(12),
    0x39: this.createSquare(2, 2, 60),
    0x28: this.createSquare(2, 2, 88),

    0xe1: this.createSquare(2, 2, 90),
    0xe5: this.createSquare(2, 2, 100),
    0x52: this.createSquare(54.4, 2),

    0x2c: this.createSquare(2, 2, 316),
    0x50: this.createSquare(13),
  }

  speedAllowValues: number[] = [4, 3, 2, 1, 0]
  lightAllowValues: number[] = generateArray(0, 5)

  lockWin: boolean = true

  rate: number[] = [1]
}
